<template>
  <div class="section-column  section-content serp-input-container">
     <div class="header-actions-container">
        <div class="dark-mode-wrapper">
          <span
            class="dark-mode-text"
            :class="darkModeOn"
            >Dark Mode</span>
            <span
              class="toggle-wrapper"
              role="checkbox"
              :aria-checked="darkMode.toString()"
              tabindex="0"
              @click="toggle"
              @keydown.space.prevent="toggle"
            >
            <span
              class="toggle-background"
              :class="backgroundStyles"
            />
            <span
              class="toggle-indicator"
              :style="indicatorStyles"
            />
          </span>
        </div>
        <div class="download-image-wrapper">
          <button v-on:click="downloadSerp" class="primary-button" :class="darkModeOn">Download</button>
        </div>
      </div>
    <div class="serp-image-wrapper" id="serp-preview-image">
      <div
          class="serp-header"
          :class="darkModeOn"
        >
        <div class="header-top-container">
          <div class="logo-container">
            <img width="92" height="30" class="logo" src="../assets/google-logo.png">
          </div>

          <div class="search-bar-outer">

            <div class="search-bar-container">
              <input name="search-input" class="search-input" type="text">
              <div class="icon-container">
                <i class="mic"></i>
              </div>
              <div class="icon-container">
                <i class="search"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="search-bottom-container">
          <ul class="button-list">
            <li class="search-buttons">
              <a class="active" href="#">All</a>
            </li>
            <li class="search-buttons">
              <a href="#">Maps</a>
            </li>
            <li class="search-buttons">
              <a href="#">Images</a>
            </li>
            <li class="search-buttons">
              <a href="#">Videos</a>
            </li>
            <li class="search-buttons">
              <a href="#">News</a>
            </li>
            <li class="search-buttons">
              <a href="#">More</a>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="serp-preview"
        :class="darkModeOn"
        >
        <div class="serp-preview-wrapper">
          <ul class="url">
            <li v-for="(parts, i) in urlParts" :key="i" :class="parts.class" v-text="parts.text"></li>
          </ul>
          <h3 v-text="titleCanon">
          </h3>
          <span v-text="descriptionCanon">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateWidthMeasurer from 'measure-text-width';
import * as htmlToImage from 'html-to-image';

const measureUrlWidth = CreateWidthMeasurer(window).setFont('14px Arial');
const measureTitleWidth = CreateWidthMeasurer(window).setFont('20px Arial');
const measureDescriptionWidth = CreateWidthMeasurer(window).setFont('14px Arial');

export default {
  name: 'SerpPreview',
  props: {
    url: {
      type: String,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  data() {
    return {
      darkMode: false,
    };
  },
  watch: {
    urlWidth(newVal) {
      this.$emit('urlsizechange', newVal);
    },
    titleWidth(newVal) {
      this.$emit('titlesizechange', newVal);
    },
    descriptionWidth(newVal) {
      this.$emit('descriptionsizechange', newVal);
    },
  },
  computed: {
    backgroundStyles() {
      return {
        'gold-mid': this.darkMode,
        'gray-lighter': !this.darkMode,
      };
    },
    darkModeOn() {
      return {
        'light-mode': !this.darkMode,
        'dark-mode': this.darkMode,
      };
    },
    indicatorStyles() {
      return { transform: this.darkMode ? 'translateX(14px)' : 'translateX(0)' };
    },
    descriptionWidth() {
      return measureDescriptionWidth(this.description);
    },
    descriptionCanon() {
      if (this.descriptionWidth < 990) {
        return this.description;
      }
      return this.splitThroughPixel(this.description, 990, 'description');
    },
    titleWidth() {
      return measureTitleWidth(this.title);
    },
    titleCanon() {
      if (this.titleWidth < 575) {
        return this.title;
      }
      return this.splitThroughPixel(this.title, 575, 'title');
    },
    urlWidth() {
      return measureUrlWidth(this.url);
    },
    urlParts() {
      let url;

      if (!this.url) {
        return [];
      }

      try {
        url = new URL(this.url);
      } catch (e) {
        return [];
      }

      const parts = [];
      let currentUrl = '';

      if (url.host) {
        currentUrl = `${url.protocol}//${url.host}`;
        parts.push({
          class: 'domain',
          text: `${url.protocol}//${url.host}`,
        });
      }

      if (url.pathname) {
        const pathParts = url.pathname.split('/');
        let truncated = false;
        pathParts.shift();

        pathParts.forEach((part) => {
          if (!part || truncated) {
            return;
          }

          const doTruncate = this.truncated(360, currentUrl, part);
          if (doTruncate === true) {
            truncated = true;
            return;
          }
          if (typeof doTruncate === 'string') {
            truncated = true;
            parts.push({
              class: 'path',
              text: `${doTruncate}`,
            });
            return;
          }

          currentUrl = `${currentUrl}${part}`;
          parts.push({
            class: 'path',
            text: part,
          });
        });
      }

      return parts;
    },
  },
  methods: {
    truncated(pixels, base, extra) {
      const baseLength = measureUrlWidth(base);
      const extraLength = measureUrlWidth(extra);
      if ((baseLength + extraLength) <= pixels) {
        return false;
      }
      if (baseLength > pixels) {
        return true;
      }
      const pixelWidth = 360 - baseLength;
      return this.splitThroughPixel(extra, pixelWidth, 'url');
    },
    // This functions takes a string, width and a string type and outputs a string that is split to the correct pixel depending on the type &
    splitThroughPixel(string, width, type) {
      const words = string;
      const response = [];
      let currentString = '';
      let measureFunction;

      for (let i = 0; i < words.length; i++) {
        const currentLetter = words[i];
        const temp = currentString + currentLetter;

        if (type === 'url') {
          measureFunction = measureUrlWidth(temp);
        } else if (type == 'title') {
          measureFunction = measureTitleWidth(temp);
        } else if (type === 'description') {
          measureFunction = measureDescriptionWidth(temp);
        }
        if (measureFunction > width) {
          response.push(`${currentString.substr(0, i)}...`);
          return response[0];
        }
        currentString = temp;
      }
      return response[0];
    },
    toggle() {
      this.darkMode = !this.darkMode;
    },
    download(fileUrl, fileName) {
      const a = document.createElement('a');
      a.href = fileUrl;
      a.setAttribute('download', fileName);
      a.click();
    },
    downloadSerp() {
      const node = document.getElementById('serp-preview-image');
      this.$nextTick(() => {
        htmlToImage.toPng(node)
          .then((dataUrl) => {
            const img = new Image();
            img.src = dataUrl;
            this.download(img.src, 'serp-preview');
          })
          .catch((error) => {
            console.error('oops, something went wrong!', error);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.header-actions-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    flex-direction: column;

  @media only screen and (min-width: 1024px) {
    flex-direction: row;
  }
}

.dark-mode-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
    padding-bottom: 20px;

  @media only screen and (min-width: 1024px) {
    padding-bottom: 0;
    justify-content: flex-start;
  }
}

.dark-mode-text {
  padding-right: 5px;
  font-size: 14px;
  color: white;

  &.dark-mode {
  color: #bdc1c6;
  }
}

.gold-mid{
  background-color: #666666;
}

.gray-lighter{
  background-color: #c2c2c2;
}

.toggle-wrapper {
  display: flex;
  position: relative;
  cursor: pointer;
  width: 32px;
  height: 18px;
  border-radius: 9999px;
  align-self: center;
}

.toggle-wrapper:focus {
  outline: 0;
}

.toggle-background {
  display: inline-block;
  border-radius: 9999px;
  height: 100%;
  width: 100%;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color .4s ease;
}

.toggle-indicator {
  position: absolute;
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  border-radius: 9999px;
  box-shadow:  0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform .4s ease;
}

.serp-preview-container {
  display: block;
  position: relative;
  width: 640px;
}

.serp-header {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 5px 5px 0 0;
  padding: 20px;
  background-color: white;
  overflow: hidden;
  transition: background-color 0.3s, border 0.3s;

  @media only screen and (min-width: 1024px) {
    background-color: #f8f8f8;
  }

  &.dark-mode {
    background-color: #202124;
    border-bottom: none;
    border-color: #202124;

    .search-input {
      background-color: #303135;
      border-color: transparent
    }

    .search-bottom-container {

      a {
        color: #969ba1;

        &.active {
          color: #8ab4f8;

          &:after {
            background-color: #8ab4f8;
          }
        }
      }
    }
  }
}

.header-top-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

    @media only screen and (min-width: 1024px) {
      flex-direction: row;
    }
}

.logo-container {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;

    @media only screen and (min-width: 1024px) {
      margin: 0 10px 0 0;
      width: 17%;
      justify-content: flex-start;
      align-items: center;
    }
}

.search-bar-outer {
  width: 100%;
}

.search-bar-container {
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 20px;

  @media only screen and (min-width: 1024px) {
    padding-top: 0;
  }

 .search-input {
    box-sizing: border-box;
    width: 100%;
    height: 30px;
    margin: 0 0 1rem;
    padding: .5rem;
    border: 1px solid #cacaca;
    border-radius: 2px;
    width: 100%;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0px 2px 5px 0px rgb(60 64 67 / 16%);
    transition: background-color 0.3s, border 0.3s;

    @media only screen and (min-width: 1024px) {
    box-shadow: none;
    }
  }
}

.search-bottom-container {
  display: flex;
  width: 100%;

  .button-list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;

    a {
      text-decoration: none;
      color: #969ba1;

      &.active {
        color: #1a73e8;

          &:after {
            display: block;
            content: "";
            width: 100%;
            height: 2px;
            background-color: #1a73e8;
          }
      }
    }
  }

  .search-buttons {
    padding: 0 20px 0 0;
    text-decoration: none;
  }
}

.serp-preview {
  display: block;
  width: 100%;
  padding: 20px;
  border: 1px solid #e8e8e8;
  font-family: Arial, sans-serif !important;
  background-color: #fff;
  transition: background-color 0.3s, border 0.3s;

  &.dark-mode {
    background-color: #202124;
    border-color: #202124;
    border-top: 1px solid #3c4043;

    .serp-preview-wrapper {

      span {
        color: #bdc1c6;
      }

      h3 {
        color: #8ab4f8;
        }

      ul.url {
        color: #bdc1c6;

        li:after {
          color: #969ba1;
        }
        .path {
          color: #969ba1;
        }
      }
    }
  }

  .serp-preview-wrapper {
   max-width: 575px;

    > ul.url {
      display: block;
      list-style: none;
      padding: 0;
      margin: 0;
      font-size: 14px;
      line-height: 1.3;
      color: #202124;
      font-family: Arial,sans-serif;

      li {
        display: inline-block;
        font-family: Arial,sans-serif;

        &:not(:last-child) {
          padding-right: 4px;

          &:after {
            content: '›';
            display: relative;
            margin-left: 4px;
            color: #5f6368;
          }
        }

        &.path {
          color: #5f6368;
        }
      }
    }

    > h3 {
      font-weight: normal;
      color: #1a0dab;
      padding-top: 5px;
      line-height: 1.3;
      margin: 0;
      max-width: 575px;
      font-size: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      font-family: Arial,sans-serif;

      @media only screen and (min-width: 1024px) {
        white-space: nowrap;
      }
    }

    > span {
      margin: 0;
      font-weight: normal;
      color: #4d5156;
      font-size: 14px;
      line-height: 1.58;
      font-family: Arial,sans-serif;
    }
  }
}
</style>
